module.exports = __webpack_public_path__ + "img/logo-pixelhobby.6cf982de.png";